<template>
  <div>
    <el-row :gutter="10">
      <el-col :l="24" :xl="12">
        <el-card>
          <div slot="header" class="clearfix">
            <div class="custom-head-card">
              <h2>{{ cardTitle | upper }}</h2>
              <el-popover
                placement="top-start"
                title="Info"
                width="200"
                trigger="hover"
                content="Create a new 'Ordre de fabrication'">
                <el-button style="float: right; padding: 3px 0" type="text" slot="reference">Info</el-button>
              </el-popover>
            </div>
          </div>
          <app-createof></app-createof>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CreateOf from '@/components/of/CreateOf.vue'
import getFormState from '../mixins/GetFormState'

export default {
  name: 'Snippet',
  components: {
    'app-createof': CreateOf,
  },
  props: { },
  data() {
    return {
      msg: 'Hi there!',
      cardTitle: 'OF FORM',
     
    }
  },
  created() {
    this.cardTitle = `${this.getFormState()} ${this.cardTitle}`;
  },
  computed: {
    reverse: function () {
      return this.msg.split('').reverse().join('');
    }
  },
  methods: {
    sayHi: function() {
      return 'hi';
    }
  },
  mixins: [getFormState]
}
</script>

<style scoped>
  .super-class {
    background: #4b79b6;
  }

  .custom-head-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .custom-head-card > h2 {
    margin: 0.2rem;
  }

</style>